var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallToActionArrowButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14.1429,
    rx: 7.07143,
    fill: "#F4F7F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78349 5.25511C9.78572 5.01843 9.59566 4.82475 9.35898 4.82252L5.50201 4.7862C5.26532 4.78397 5.07165 4.97403 5.06942 5.21071C5.06719 5.44739 5.25725 5.64107 5.49393 5.6433L8.92235 5.67559L8.89006 9.10401C8.88783 9.34069 9.07789 9.53437 9.31458 9.5366C9.55126 9.53883 9.74494 9.34877 9.74717 9.11208L9.78349 5.25511ZM5.94523 9.19762L9.65512 5.55696L9.05476 4.94519L5.34487 8.58585L5.94523 9.19762Z",
    fill: "#1C2E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallToActionArrowButton);
export default __webpack_public_path__ + "static/media/CallToActionArrowButton.0eec0587aea6234efcd9ac10ea331247.svg";
export { ForwardRef as ReactComponent };